import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer } from '@ngrx/store';

export const editPresenceContactFeatureKey = 'editPresenceContact';

export interface EditPresenceContactState {
   callState: CallState;
}

export const initialState: EditPresenceContactState = {
   callState: LoadingState.Init,
};

const editPresenceContactReducer = createReducer(initialState);

export function reducer(state: EditPresenceContactState | undefined, action: Action) {
   return editPresenceContactReducer(state, action);
}
